let quotesData = null;
let allDukascopyForex = ['ADA/USD',
	'AUD/CAD',	'AUD/CHF',	'AUD/JPY',	'AUD/NZD',	'AUD/SGD',	'AUD/USD',
	'AVE/USD',	'BAT/USD',	'BCH/USD',	'BTC/USD',	'CAD/CHF',	'CAD/HKD',
	'CAD/JPY',	'CHF/JPY',	'CHF/SGD',	'CMP/USD',	'DSH/USD',	'ENJ/USD',
	'EOS/USD',	'ETH/USD',	'EUR/AUD',	'EUR/CAD',	'EUR/CHF',	'EUR/CZK',
	'EUR/DKK',	'EUR/GBP',	'EUR/HKD',	'EUR/HUF',	'EUR/JPY',	'EUR/NOK',
	'EUR/NZD',	'EUR/PLN',	'EUR/RUB',	'EUR/SEK',	'EUR/SGD',	'EUR/TRY',
	'EUR/USD',	'GBP/AUD',	'GBP/CAD',	'GBP/CHF',	'GBP/JPY',	'GBP/NZD',
	'GBP/USD',	'HKD/JPY',	'LNK/USD',	'LTC/USD',	'MAT/USD',	'MKR/USD',
	'NZD/CAD',	'NZD/CHF',	'NZD/JPY',	'NZD/USD',	'SGD/JPY',	'TRX/USD',
	'TRY/JPY',	'UNI/USD',	'USD/CAD',	'USD/CHF',	'USD/CNH',	'USD/CZK',
	'USD/DKK',	'USD/HKD',	'USD/HUF',	'USD/ILS',	'USD/JPY',	'USD/MXN',
	'USD/NOK',	'USD/PLN',	'USD/RON',	'USD/RUB',	'USD/SEK',	'USD/SGD',
	'USD/THB',	'USD/TRY',	'USD/ZAR',	'XAG/USD',	'XAU/USD',	'XLM/USD',
	'XMR/USD',	'YFI/USD',	'ZAR/JPY'];

function _getQuotesData(oB) {
	quotesData = oB;
}

(function($) {
	$window.on('load', function() {
		// Converter on main page
		if ($('.currency-converter').length) {
			var converterFromInput = 1,
			    inCurrInput = $('#currency-in'),
			    outCurrInput = $('#currency-out');
			applyCurr = function(sTitle,targetID) {
				var target = document.getElementById(targetID);
				var stmp = sTitle.split('(');
				stmp = stmp[1].split(')');
				var curr = stmp[0];
				//alert(curr);
				//console.log(target);
				target.value = curr;
				if(targetID.indexOf('-in') > -1) {
					//converterFromInput = 1;
				}
				else{
					//converterFromInput = 2;	
				}
				runConevrter();
			}
			// coneverterBlur = function(el) {
			// 	var btn 			= document.getElementById('converterSubmitBtn');
			// 	btn.className 		= 'arrows';
			// 	converterFromInput 	= el;
			// }
			converterInputChange = function(number) {
				converterFromInput 	= number;
				runConevrter();
			}

			runConevrter = function() {
				var btn = document.getElementById('converterChangeCurr');
				btn.className = 'arrows process-rotation';
				var animStart = Date.now();

				if(converterFromInput == 1) {
					var amount 	= document.getElementById('amount1').value;
					var from   	= document.getElementById('currency-in').value;
					var to   	= document.getElementById('currency-out').value;
					var r = $('#amount2').parents('.currency-block').addClass('active');  
		  			setTimeout(function() {r.removeClass('active')},1000);
				}
				else{
					var amount 	= document.getElementById('amount2').value;
					var from   	= document.getElementById('currency-out').value;
					var to   	= document.getElementById('currency-in').value;
					var r = $('#amount1').parents('.currency-block').addClass('active');
		  			setTimeout(function() {r.removeClass('active')},1000);
				}

				goAllConvert = function(price, amount, $c1, $c2) {

					let rez = simpleConvert(price, amount, $c1, $c2);
					if(rez === false) {
						let step1 = simpleConvert(price, amount, $c1, 'USD');
						if(step1) {
							let step2 = simpleConvert(price, step1, 'USD', $c2);
							if(step2) {
								return step2;
							}
						}
						else{
							let step1 = simpleConvert(price, amount, $c1, 'EUR');
							if(step1) {
								let step2 = simpleConvert(price, step1, 'EUR', $c2);
								if(step2) {
									return step2;
								}
							}
						}
					}
					return rez;
				}

				simpleConvert = function(price, $amount, $c1, $c2) {

					let rez = false;
					if(allDukascopyForex.includes($c1+'/'+$c2)) {
						for(let i in price) {
							if(price[i].id == $c1+'/'+$c2) {
								rez = price[i].ask * $amount;
								break;
							}
						}
					}
					else if(allDukascopyForex.includes($c2+'/'+$c1) ) {
						for(let i in price) {
							if(price[i].id == $c2+'/'+$c1) {
								rez = $amount / price[i].bid ;
								break;
							}
						}
					}
					return rez;
				}

				if(quotesData != null) {
					let tergOutput = (converterFromInput == 1) ? document.getElementById('amount2') : document.getElementById('amount1');
					let rez = goAllConvert(quotesData, amount, from, to)
					tergOutput.value = (rez == false) ? '?' : rez.toFixed(2);
					let animCurrentDuration = Date.now() - animStart;
					let animIntegerDuration = Math.ceil(animCurrentDuration/1000)*1000;
					setTimeout(function() {btn.className = 'arrows';}, animStart + animIntegerDuration - Date.now());
				}
				else{

					$.ajax({
						url: 'https://freeserv.dukascopy.com/2.0/index.php?path=swfx_widget%2FgetQuotes&instruments='+ allDukascopyForex.join(','),
	//					url: 'https://freeserv.dukascopy.com/2.0/index.php?path=swfx_widget%2FgetQuotes',
						method: 'GET',
						cache: false,
						dataType: 'jsonp',
						timeout: 2000,
						jsonp: 'jsonp',
						jsonpCallback: '_getQuotesData',
						success: function(data,status,xhr) {
							// console.log('data', status, data);
							console.log(quotesData);
								let tergOutput = (converterFromInput == 1) ? document.getElementById('amount2') : document.getElementById('amount1');
								let rez = goAllConvert(quotesData, amount, from, to)
								tergOutput.value = (rez == false) ? '?' : rez.toFixed(2);
								let animCurrentDuration = Date.now() - animStart;
								let animIntegerDuration = Math.ceil(animCurrentDuration/1000)*1000;
								setTimeout(function() {btn.className = 'arrows';}, animStart + animIntegerDuration - Date.now());
						},
						error : function(jqXhr, textStatus, errorMessage){
							let tergOutput = (converterFromInput == 1) ? document.getElementById('amount2') : document.getElementById('amount1');
							tergOutput.value = '?';
							let animCurrentDuration = Date.now() - animStart;
							let animIntegerDuration = Math.ceil(animCurrentDuration/1000)*1000;
							setTimeout(function() {btn.className = 'arrows';}, animStart + animIntegerDuration - Date.now());
							//                console.log('error',textStatus, errorMessage);
						}
					});

				}
				// $.post( "/plugins/converter/ajax_2018.php", { 'amount': amount, 'from': from, 'to':to })
				//   .done(function( data ) {
				// 	var tergOutput = (converterFromInput == 1) ? document.getElementById('amount2') : document.getElementById('amount1');
				//     tergOutput.value = data;
				//     var animCurrentDuration = Date.now() - animStart;
				//     var animIntegerDuration = Math.ceil(animCurrentDuration/1000)*1000;
				//     setTimeout(function() {btn.className = 'arrows';}, animStart + animIntegerDuration - Date.now());
				//   });

			}
			$('#converterChangeCurr').click(function() {
				var bufer = inCurrInput.val();
				inCurrInput.val(outCurrInput.val());
				outCurrInput.val(bufer);
				runConevrter();
			});
			var bsFiredElem = $('.cc-dropdown').parent();
			bsFiredElem.on('show.bs.dropdown', function() {
				var $this = $(this),
				    currInput = $this.find('.curr-val'),
				    currList = $this.find('.dropdown-menu'),
				    currListItems = currList.find('li').show(); //Because of filter
				$this.data('last-currency', currInput.val());
				currInput.val('');
				currInput.on('keyup.cc', function(e) {
					if (e.which == 13) {
						$this.parents('form').submit();
						$body.click();
					} else {
						currListItems.each(function() {//Filter
							var $this = $(this);
							$this.show();
							if (!new RegExp(currInput.val(), 'i').test($this.text())) {
								$this.hide();
							}
						});
					}
				});
				bsFiredElem.on('hide.bs.dropdown', function() {
					if (currInput.val() === '') {
						currInput.val($this.data('last-currency'));
					}
					currInput.off('keyup');
					bsFiredElem.off('hide.bs.dropdown');
				});
			});
			runConevrter();
		}
	});
})(jQuery)